export default __webpack_public_path__ + "static/media/DNo.15-2.9d3f83ad.jpg";